module.exports = __webpack_public_path__ + "static/media/siddharth-tirupati-trip-06.aa285bd1.png";